import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fullPageLoader, updateAlertMessage, updateIsSessionExpired, updateTileInfo, updatePageTranslation, updateUser, updatePageMemory, updateBLCUserGroup, updateLogout, selectBlcUserGroup, selectUser, selectIsLoggedIn } from "../../../api-integration/common.slice";
import { useCheckBLCAdminSecurityMutation } from "../../../api-integration/secure/secure";
import { useGetUserProfileMutation } from "../../../api-integration/secure/api.account";
import { useEffect } from "react";
import { getPageByURL, getTranslatedText, resolveSessionExpiredMessage } from "../../../util/util";
import Logo from '../../../assets/images/logo.png';
import { useGetPageTileInfoMutation } from "../../../api-integration/public/public";
import usePageTranslation from "../../../hooks/ui/usePageTranslation";


const Header = () => {
  const PageTranslation = usePageTranslation();
  const blcUserGroup = useAppSelector(selectBlcUserGroup);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const pageName = getPageByURL(location.pathname); 
  

  const [pageTileInfoAPI, { data: pageTileInfo, isSuccess: isPageTileInfoSuccess, isError: isPageTileInfoError, error: pageTileInfoError }] =
    useGetPageTileInfoMutation();

  const [getUserDetailsAPI] = useGetUserProfileMutation();

    const [checkBLCAdminSecurityAPI, {data: securityData, isSuccess: isSecurityDataSuccess, isError: isSecurityDataError, error: securityDataError}] 
    = useCheckBLCAdminSecurityMutation();

  // const logout = () => {
  //   dispatch(fullPageLoader(true));
  //   logoutAPI({});
  // };

  useEffect(() => {
    if(
      (blcUserGroup?.blcAdmin === null) || 
      (isLoggedIn 
      && 
      (
        location.pathname.includes('/app/admin') || 
        location.pathname.includes('/home') || 
        location.pathname.includes("/company") || 
        location.pathname.includes("/actionDeck")
      )) 
    ) 
      {
      checkBLCAdminSecurityAPI({page: 'internalAdminPortal'});
    }
  },[location?.pathname]);

  const initialBlcUserGroup = {
    blcAdmin: 0,
    blcSystemManager: 0,
    blcPortalManager: 0,
    isAdmin: 0
  };

  useEffect(() => {
    if(isSecurityDataSuccess) {
      if(securityData?.success === true) {
        dispatch(updateBLCUserGroup({
          blcAdmin: securityData?.blcUserGroup?.blcAdmin,
          blcSystemManager: securityData?.blcUserGroup?.blcSystemManager,
          blcPortalManager: securityData?.blcUserGroup?.blcPortalManager,
          isAdmin: securityData?.blcUserGroup?.isAdmin ?? 0
        }));
      }
      else {
        dispatch(updateBLCUserGroup(initialBlcUserGroup));
      }
    }
    else if(isSecurityDataError || securityDataError) {
      dispatch(updateBLCUserGroup(initialBlcUserGroup));
    }
  },[isSecurityDataSuccess, isSecurityDataError, securityDataError]);

  useEffect(() => {
    if (location.pathname) {
      if (pageName) {
        dispatch(fullPageLoader(true));

        const promises = [
          pageTileInfoAPI({
            "Page": pageName
          })
        ];
        // The user object always exists in the store, even when logged out.
        // In that case, it contains default values like userId = 0.
        // Therefore we check userId !== 0 to confirm the user is truly logged in.
        if (isLoggedIn || (user !== null && user?.userId !== 0)) {
          const userDetailsPromise = getUserDetailsAPI({});
          userDetailsPromise.then(response => {
            // Check if response has a data property
            if ('data' in response && response?.data?.user) {
              const languagePreference = response.data.user.preferences?.userLanguage;
              localStorage.setItem('userLanguage', languagePreference);
              // Update local storage on success
              const localUser = {
                userEmail: response?.data?.user?.email,
                userBusinessEmail: response?.data?.user?.businessemail,
                userId: response?.data?.user?.userId,
                username: response?.data?.user?.username,
                userType: response?.data?.user?.userType,
                userlevel: response?.data?.user?.userlevel,
                firstName: response?.data?.user?.firstName,
                lastName: response?.data?.user?.lastName,
                picPath: response?.data?.user?.picPath,
                totalCCPoints: response?.data?.user?.totalCCPoints,
                userCCBalance: response?.data?.user?.userCCBalance,
                orgCCBalance: response?.data?.user?.orgCCBalance,
                orgLowCoinAlert: response?.data?.user?.orgLowCoinAlert,
                usrCreatedDate: response?.data?.user?.usrCreatedDate,
                referralId: response?.data?.user?.referralId,
                blcFlag: response?.data?.user?.blcFlag,
                betaUser: response?.data?.user?.betaUser,
                accId: response?.data?.user?.accId,
                orgId: response?.data?.user?.orgId,
                accountType: response?.data?.user?.accountType,
                showRefKey: response?.data?.user?.showRefKey,
                isNewUser: response?.data?.user?.isNewUser,
                showWelcomeNote: response?.data?.user?.isNewUser,
                isProfileComplete: response?.data?.user?.isProfileComplete,
                promptExeAlert: response?.data?.user?.preferences?.promptExeAlert,
                userLanguage: response?.data?.user?.preferences?.userLanguage,
                paginationRecordsPerPage: response?.data?.user?.preferences?.userPaginationRecordsPerPage,
                emailPrivacy: response?.data?.user?.preferences?.userPrivacy,
                sysUsageLevel: response?.data?.user?.sysUsageLevel,
                usrMessageAlertDuration: response?.data?.user?.preferences?.usrMessageAlertDuration,
                userPreferences: response?.data?.user?.preferences,
                userCompanyData: response?.data?.user?.companyData,
                userNotifications: response?.data?.user?.userNotifications,
                CCtoCHF: response?.data?.user?.CCtoCHF,
                userDeveloperAccess: response?.data?.user?.developerAccess,
                userRoles: response?.data?.user?.userRoles,
                userRights: response?.data?.user?.userRights,
                blcPremiumFee: response?.data?.user?.blcPremiumFee,
                visitedTeamPage: response?.data?.user?.visitedTeamPage                
              }
              dispatch(updateUser(localUser));
            }
            else{
              /*
                User's status is loggedIn in react but API did not return any data 
                  - either accessToken does not exists in HHTP only COOKIE
                  - OR ACCESSTOKEN is expired  
                Logout the user from react application
              */
              clearAndLogout();
            }
          });
          promises.push(userDetailsPromise);
        }
  
      Promise.all(promises)
        .then(() => {
          dispatch(fullPageLoader(false));
        })
        .catch(() => {
          dispatch(fullPageLoader(false));
        })
        .finally(() => {
          dispatch(fullPageLoader(false));
        });
      }
    }
  }, [location.pathname, pageName]);

  const clearAndLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(updateLogout());
    dispatch(updateIsSessionExpired(false));
    const translatedMsg = getTranslatedText('sessionExpired.message', PageTranslation);
    const alertMsg = resolveSessionExpiredMessage(translatedMsg);
    dispatch(updateAlertMessage({ status: 'error', message: alertMsg }));
    navigate('/login');
  }

  useEffect(() => {
    if (isPageTileInfoSuccess) {
      if (pageTileInfo?.statusCode === 200 && pageTileInfo?.success === true) {
        dispatch(fullPageLoader(false));
        dispatch(updateTileInfo(pageTileInfo?.TileInfo));
        dispatch(updatePageTranslation(pageTileInfo?.pageTranslation));
        dispatch(updatePageMemory(pageTileInfo?.pageMemory));
        //let tileIsLoggedIn = pageTileInfo?.isLoggedIn;
        
        // if (!tileIsLoggedIn && (isLoggedIn || user !== null)) {
        //   //dispatch(updateAlertMessage({ status: 'error', message: t('message.session_expired') }));
        //   //localStorage.clear();
        //   //navigate('/login');
        // }
      } else {
        dispatch(fullPageLoader(false));
        dispatch(updateAlertMessage({ status: 'error', message: pageTileInfo?.message }));
      }
    }
    if (pageTileInfoError || isPageTileInfoError) {
      dispatch(fullPageLoader(false));
      dispatch(updateAlertMessage({ status: 'error', message: getTranslatedText('errorRatingCard.message',PageTranslation) }));
    }
  }, [isPageTileInfoSuccess, pageTileInfoError, isPageTileInfoError]);
  

  return (
    <>
    {(pageName === 'login' || pageName === 'eventLogin') ? null : (
    <div className="header p-5 d-flex justify-content-between align-items-center">
      <img src={(user?.userCompanyData?.companyLogoPath as string) || Logo} className="logo" alt= {getTranslatedText('imageAlt.text', PageTranslation)}/>

      {/* <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        Language: {language}
      </a>
      <ul className="dropdown-menu">
        <li>
          <a className="dropdown-item" 
            href="#" 
            onClick={(event) => {
              event.preventDefault();
              handleLanguageChange('en');
            }}
          >
            English
          </a>
        </li>
        <li>
          <a className="dropdown-item" 
            href="#" 
            onClick={(event) => {
              event.preventDefault();
              handleLanguageChange('vi');
            }}
          >
            vietnamese
          </a>
        </li>
      </ul> */}
    </div>
    )}
    </>
  )
}

export default Header;